// extracted by mini-css-extract-plugin
module.exports = {"contract":"Contract-module--contract--39mel NumberUnit-module--unit--1piM6","action":"Contract-module--action--Na5F6"};